//
import { RequiredRule } from '@/mixins/reusable_mixins/rules'

//
export default [
    {
        name: 'provider_code',
        type: 'text-field',
        props: {
            label: 'Código de proveedor',
            rules: [RequiredRule],
        },
    },
    {
        name: 'name',
        type: 'text-field',
        props: {
            label: 'Nombre',
            rules: [RequiredRule],
        },
    },
    {
        name: 'price',
        type: 'currency-field',
        props: {
            label: 'Precio',
            reverse: true,
            rules: [RequiredRule],
        },
    },
    {
        name: 'quantity',
        type: 'float-field',
        props: {
            label: 'Cantidad',
            reverse: true,
            rules: [RequiredRule],
        },
    },
    {
        name: 'is_cyclic',
        type: 'switch',
        props: {
            class: 'pt-3',
            label: 'Cíclico',
        },
    },
]
